import React, { useState, useEffect } from "react";
import { Row, Container, Col } from "react-bootstrap";
import { GlobalState } from "contexts/GlobalState";
import { ProfileView } from "./components/ProfileView";
import { ProfileEdit } from "./components/ProfileEdit";
import { UPDATE_USER } from "schemas/profile";
import { useMutation } from "@apollo/client";
import useCalc from "hooks/useCalc";
import "./style.scss";


export const ProfileCard = ({ labels }) => {
  const INPUT_FIELDS = ["psycho", "maturity"];
  const {
    formFields,
    buildJsonAndCallLastScore,
    showResult
  } = useCalc(labels, INPUT_FIELDS, false);
  const [globalUser, setGlobalUser] = GlobalState("user");
  const [active, setActive] = useState("ProfileView");
  const [updateUser, { data: data, error: error }] = useMutation(UPDATE_USER);
  const [cardOpen, setCardOpen] = useState(true);
  const [adapterScore, setAdapterScore] = useState(false);
  const getCookie = (name) => {
    const cookieValue = document.cookie
      .split('; ')
      .find(row => row.startsWith(`${name}=`))
      .split('=')[1];
    return cookieValue;
  };
  useEffect(() => {
    if (formFields.adapter) {
      setAdapterScore(true);
      updateUser({
        variables: {
          psychometric: formFields?.psycho?.toString(),
          maturity: formFields?.maturity?.toString(),
          adapter: formFields?.adapter?.toString(),
          filters: globalUser.user.filters ?? {},
          registrationFormChoices: globalUser.user.registrationFormChoices ?? {},
        },
      });
    }
  }, [showResult, formFields])


  const logout = () => {
    const token = getCookie("jwt");
    const requestMetadata = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    };
    fetch(`${window.location.origin}/auth/logout`, requestMetadata)
      .then((response) => {
        if (response.status == 200) {
          window.location.assign(labels.homepage_url);
        } else {
          alert(labels.error_msg);
        }
      })
      .catch((error) => {
        alert(labels.error_msg);
      })
  }
  const calculateScore = (psychometric, maturity) => {
    const jsonParams = {};
    jsonParams.psycho = psychometric;
    jsonParams.maturity = maturity;
    jsonParams.reali10 = 0;
    buildJsonAndCallLastScore(jsonParams);
  }

  const hideComponents = (name, psychometric, maturity) => {
    var active = name;
    var newActive = active === "ProfileView" ? "ProfileEdit" : "ProfileView";
    setActive(newActive);
    if (name == "ProfileEdit") {
      calculateScore(psychometric, maturity)
    }
  };
  useEffect(() => {
    if (data) {
      setGlobalUser({
        user: { ...data.updateUser },
      });
    }
    if (error) {
      console.log(error);
    }
  }, [data, error]);
  return (
    <Container className="profile-card">
      {globalUser.user && (
        <div>
          <Row className="logout-row">
            <button aria-label={labels.logout} className="logout-btn" onClick={() => logout()}>
              <div className="logout-img" />
              <span>{labels.logout}</span>
            </button>
            {Utils.isMobile() && (
              <div
                role="button"
                className={`open-close-btn ${cardOpen ? "expanded" : ""}`}
                onClick={() => setCardOpen(prevState => !prevState)} />
            )}
          </Row>
          {cardOpen === true && (
            <Row className="user-info-row">
              <Col>
                {!Utils.isMobile() && (
                  <div className="image" />
                )}
                <div className="details">
                  <div className="name">{globalUser.user.fullName}</div>
                  <div className="phone">{globalUser.user.phone}</div>
                  <div className="degree">{globalUser?.user?.registrationFormChoices?.degree ? `${labels.towards} ${globalUser.user.registrationFormChoices.degree}` : null}</div>
                </div>
                {active === "ProfileView" ? (
                  <ProfileView
                    labels={labels}
                    onClick={hideComponents}
                  ></ProfileView>
                ) : active === "ProfileEdit" ? (
                  <ProfileEdit
                    labels={labels}
                    onClick={hideComponents}
                  ></ProfileEdit>
                ) : null}
              </Col>
            </Row>
          )}
        </div>
      )}
    </Container>
  );
};
